// import './App.css';
import Routes from './routes/Routes';

function App() {
  //change
  return(
    <Routes/>
  )
}

export default App;
